import i18n from '@/i18n/i18n'
import TarfinProQuotationDocumentService from '@/services/admin/TarfinProQuotationDocumentService'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const state = {
  document: null,
  originalDocument: null,
  signedDocument: null,
  activeRejectedDocument: null,
  activeDeletedDocument: null
}

export const mutations = {
  SET_DOCUMENT(state, document) {
    state.document = document
  },
  SET_SIGNED_DOCUMENT(state, signedDocument) {
    state.signedDocument = signedDocument
  },
  SET_ACTIVE_REJECTED_DOCUMENT(state, activeRejectedDocument) {
    state.activeRejectedDocument = activeRejectedDocument
  },
  ADD_REJECTED_DOCUMENT(state, document) {
    state.document.rejected_documents.push(document)
    state.document.pending_document = null
  },
  SET_ORIGINAL_DOCUMENT(state, originalDocument) {
    state.originalDocument = originalDocument
  },
  APPROVE_SIGNED_DOCUMENT(state, approvedDocument) {
    state.document.approved_document = approvedDocument
    state.document.pending_document = null
  },
  DELETE_DOCUMENT(state, document) {
    state.signedDocument = null
    state.document = document
  },
  SET_ACTIVE_DELETED_DOCUMENT(state, activeDeletedDocument) {
    state.activeDeletedDocument = activeDeletedDocument
  }
}

export const actions = {
  getDocument({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.getDocument(params.quotationId, params.documentId)
        .then(response => {
          commit('SET_DOCUMENT', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.fetching_problem', {
              element: t('store.admin.document.document')
            })
          }
          dispatch('notification/add', notification, { root: true })
          reject(err)
        })
    })
  },
  uploadDocument({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.uploadDocument(params.quotationId, params.documentId, params.file)
        .then(response => {
          commit('SET_DOCUMENT', response.data)
          resolve(response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.saved', {
              element: t('store.admin.document.document')
            })
          }
          dispatch('notification/add', notification, { root: true })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewSignedDocument({ dispatch, commit }, document) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.viewSignedDocument(document.id, document.mime_type)
        .then(response => {
          commit('SET_SIGNED_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewOriginalDocument({ dispatch, commit }, documentId) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.viewOriginalDocument(documentId)
        .then(response => {
          commit('SET_ORIGINAL_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  rejectDocument({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.rejectDocument(
        params.documentId,
        params.rejectionReason,
        params.rejectionReasonDescription
      )
        .then(response => {
          commit('ADD_REJECTED_DOCUMENT', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewRejectedDocument({ dispatch, commit }, document) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.viewSignedDocument(document.id, document.mime_type)
        .then(response => {
          commit('SET_ACTIVE_REJECTED_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  approveDocument({ dispatch, commit }, documentId) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.approveDocument(documentId)
        .then(response => {
          commit('APPROVE_SIGNED_DOCUMENT', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  destroyDocument({ dispatch, commit }, documentId) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.destroyDocument(documentId)
        .then(response => {
          commit('DELETE_DOCUMENT', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('views.admin.tarfin_pro_quotation_documents.promissory_note')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewDeletedDocument({ dispatch, commit }, document) {
    return new Promise((resolve, reject) => {
      TarfinProQuotationDocumentService.viewDeletedDocument(document.id, document.mime_type)
        .then(response => {
          commit('SET_ACTIVE_DELETED_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
